export const sectionObjOne = {
    id: 'services',
    type: 1,
    lightBg: false,
    lightText: true,
    lighTextDesc: true,
    title1: 'Small Claims',
    title2: 'Court Filing',
    title3: 'Restraining Order/Divorce',
    title4: 'Order to Appear',
    title5: 'Summons and Complaint',
    title6: 'Hablamos Español',
    title7: '3D Printing',
    title8: 'Training and Consulting',
    p1: '',
    p2: '',
    p3: 'We have SolidWorks 2022 licenses and powerful computers to deliver solutions quickly, as well as specialized design engineers, with considerable experience in automation, mechanics and engineering, certified in SolidWorks at the professional and expert level (CSWP and CSWE).',
    p4: 'Construction of structures for machinery and equipment, electrical and lighting installations, industrial plumbing, grounding systems, energy saving studies, machinery and equipment installations, as well as industrial maintenance.',
    p5: 'We manufacture workstations, tables and tool trolleys using welding, aluminum and steel profiles or pipes (Creform) with LED lamps, drawers, rollers, etc. with covered wood, laminate or plastic covers.',
    p6: 'We offer you the laser cutting service using CO2 and NO2 for carbon steel, stainless steel and aluminum, among others materials.',
    p7: 'We provide SLA and FDM 3D printing technology, using materials such as PLA, ABS, PTEG, Nylon and Resin.',
    p8: 'We have SolidWorks and CNC courses, for groups and individuals, open to the public, companies or private groups, with basic, intermediate and advanced levels.',
    Icon1: require('../../img/services/claim.png').default,
    Icon2: require('../../img/services/court.png').default,
    Icon3: require('../../img/services/restraining.png').default,
    Icon4: require('../../img/services/appear.png').default,
    Icon5: require('../../img/services/complaint.png').default,
    Icon6: require('../../img/services/languages.png').default,

    alt: 'Icon',
    dark: false,
    primary: true,
    darkText: false
};
